import MuiDialog from '@mui/material/Dialog';
import styled, { css } from 'styled-components';

// Solid background (not the default translucent paper) + clip so the full-bleed
// image and content respect the paper's rounded corners.
export const Dialog = styled(MuiDialog)`
  & .MuiDialog-paper {
    height: 62rem;
    overflow: hidden;
    background: ${({ theme }) => theme.palette.background.default};
  }
`;

export const Content = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: hidden;
`;

export const ScrollArea = styled.div`
  flex: 1;
  min-height: 0;

  display: flex;
  flex-direction: column;

  overflow-y: auto;
`;

export const CloseButtonContainer = styled.div`
  position: absolute;
  top: ${({ theme }) => theme.spacing(2)};
  right: ${({ theme }) => theme.spacing(2)};

  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const Footer = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(2)};

  padding: ${({ theme }) => `${theme.spacing(4)} ${theme.spacing(4)}`};
  border-top: 1px solid ${({ theme }) => theme.palette.grey[400]};
`;

export const FooterSide = styled.div<{ $alignEnd?: boolean }>`
  display: flex;
  flex: 1;
  gap: ${({ theme }) => theme.spacing(2)};

  ${({ $alignEnd }) =>
    $alignEnd &&
    css`
      justify-content: flex-end;
    `};
`;

export const Dots = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1.5)};
`;

export const Dot = styled.span<{ $active?: boolean }>`
  width: 0.6rem;
  height: 0.6rem;
  border-radius: 50%;

  background: ${({ theme }) => theme.palette.grey[400]};
  transition: background 150ms ease;

  ${({ $active, theme }) =>
    $active &&
    css`
      background: ${theme.palette.text.primary};
    `};
`;
